import React, { useContext, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import {  PlusSquareOutlined } from "@ant-design/icons";
import "swiper/css";
import "swiper/css/pagination";
import { Button } from "antd";
import { CustomModal } from "../../../../components/CustomModal";
import { Pagination } from "swiper/modules";
import FileKeysContext from "../../../../context/fileKeysContext";
import ExpertVideosContext from "../../../../context/expertVideosContext";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createExpertVideos } from "../../../../service/api";
import ExpertVideoModal from "../modal/ExpertVideoModal";
import ExpertVideosSwiper from "./ExpertVideosSwiper";
import UploadingProcessContext from "../../../../context/uploadingProcessContext";

function ExpertVideos({ videos, loading }) {
  const [openModal, setOpenModal] = useState(false);
  const [load, setLoad] = useState()
  const { videoKey, videoCoverKey, resetFileKeysContext } =
    useContext(FileKeysContext);
  let w = document.documentElement.clientWidth || window.innerWidth;
  const [modalSize, setModalSize] = useState("");
  useEffect(() => {
    if (w > 640) {
      setModalSize("52vw");
    }
    if (w <= 640) {
      setModalSize("100vw");
    }
  }, [w]);

  const {
    title,
    description,
    tag,
    categoriesIds,
    keywords,
    resetExpertVideosContext,
  } = useContext(ExpertVideosContext);
  const { resetUploadingProcessContext } = useContext(UploadingProcessContext)

  const queryCilent = useQueryClient();

  const mutation = useMutation(createExpertVideos, {
    onMutate: () => {
      setLoad(true)
    },
    onSuccess: () => {
      setLoad(false)
      setOpenModal(false);
      return queryCilent.invalidateQueries({
        queryKey: ["contents"],
      });
    },
  });

  const onOk = () => {
    if (
      title === "" ||
      description === "" ||
      tag === "" ||
      categoriesIds.length === 0 ||
      keywords.length === 0 ||
      videoKey === '' ||
      videoCoverKey === ''
    ) {
    } else {
      // new mode
      mutation.mutate({
        title: title,
        description: description,
        categoriesIds: categoriesIds,
        keywords: keywords.map((keyword) => keyword.value),
        files: videoKey,
        cover: videoCoverKey,
        document: null,
        type: "VIDEO",
        tag: tag,
      });
    }
  };

  const addNew = () => {
    resetFileKeysContext();
    resetExpertVideosContext();
    resetUploadingProcessContext();
    setOpenModal(true);
  };

  return (
    <div className="flex flex-col bg-white max-lg:!h-fit p-4 h-full rounded-[10px] gap-5">
      {/* title */}
      <div className="text-right font-body text-[#005AC8] px-4 text-2xl font-bold">
        <h2>ویدیوهای کارشناس</h2>
      </div>
      <div>
        <h2 className="font-body text-base  ">ویدئوهای آموزشی، تبلیغاتی یا تجربه کشاورزان و خدمت‌گیرندگان خود را میتوانید در این بخش آپلود کنید تا در صفحه شخصی شما برای عموم قابل مشاهده باشد.</h2>
      </div>
      {/* swiper */}
      <div className="h-[388px] ">
        <Swiper
          dir="rtl"
          modules={[Pagination]}
          pagination={{
            dynamicBullets: true,
            clickable: true,
            renderBullet: function (index, className) {
              return (
                '<span class="' + className + '">' + (index + 1) + "</span>"
              );
            },
          }}
          breakpoints={{
            320: {
              slidesPerView: 1.1,
              spaceBetween: 10,
            },
            // when window width is >= 480px
            480: {
              slidesPerView: 1.1,
              spaceBetween: 10,
            },
            640: {
              slidesPerView: 2.2,
              spaceBetween: 15,
            },
            1600: {
              slidesPerView: 2.2,
              spaceBetween: 15,
            },
          }}
          style={{ paddingBottom: "3rem" }}
        >
          {videos && videos.length === 0 ? (
            <h2 className=" font-body font-semibold text-xl text-[#404848] mt-44 animate-pulse">
              شما هنوز ویدیو اضافه نکرده اید{" "}
            </h2>
          ) : (
            videos?.map((video, i) => (
              <SwiperSlide key={i}>
                {<ExpertVideosSwiper video={video} />}
              </SwiperSlide>
            ))
          )}
        </Swiper>
      </div>

      {/* add new button */}
      <div className="text-left px-4 ">
        <Button
          onClick={addNew}
          className="bg-gradient-to-r from-blue-800 to-sky-600 text-white "
          icon={<PlusSquareOutlined />}
        >
          افزودن جدید
        </Button>
      </div>
      {openModal && (
        <CustomModal
          loading={load}
          size={modalSize}
          visible={openModal}
          handleCancel={() => setOpenModal(false)}
          onOk={onOk}
        >
          <ExpertVideoModal />
        </CustomModal>
      )}
    </div>
  );
}

export default ExpertVideos;
